/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { colors } from '@blend/consumer-components';
import { css, StyleSheet } from 'aphrodite';
import ReactSVG from 'react-svg';

const headerHeight = 48;
const distanceFromTop = 12;

const styles = StyleSheet.create({
  logoWrapper: {
    display: 'flex',
    backgroundColor: colors.white,
    alignItems: 'center',
    width: 274,
  },
  logoImage: {
    height: headerHeight - 2 * distanceFromTop,
    marginLeft: 16,
  },
});

export namespace Logo {
  export interface Props {}
}

export const Logo: React.FC<Logo.Props> = () => {
  return (
    <div className={css(styles.logoWrapper)} data-dd-privacy="allow">
      <ReactSVG className={css(styles.logoImage)} path="../../../assets/blend-header.svg" />
    </div>
  );
};
